// What a slot IS -- read from its own fields, never from its id (Oct 2026).
// The id used to embed the location's name, so reading "_lead" out of it made every
// slot at a clinic called "Team_lead room" a lead. Generation sets slotKind
// ("lead" / "support") and slotPosition (1 = the first body of that kind).

export const slotKindOf = (shift) => shift?.slotKind ?? shift?.slot_kind ?? null;
export const isLeadSlot = (shift) => slotKindOf(shift) === 'lead';

// The solver's skill gate (required_skill): a floater may take any slot, and
// anybody else must hold EVERY skill it requires, matched exactly. Floaters
// skip only this gate -- the rank gate still applies to them.
export const meetsSkillGate = (emp, shift) => {
  if (emp?.is_floater || emp?.isFloater) return true;
  const rs = shift?.required_skill || shift?.requiredSkill;
  if (!rs) return true;
  const held = emp?.skills || [];
  return (Array.isArray(rs) ? rs : [rs]).every(s => held.includes(s));
};
